import React, { useState, useEffect } from "react";
import CustomButton from "./CustomButton";
//import styled from 'styled-components';
//import TVButton from './TVButton';
//import useRemoteControl from '../hooks/useRemoteControl';
let selectedElementIndx = 0;
let resolution = window.RESOLUTION;

const WelcomeScreen = ({ navigate }) => {
  const [state, setState] = useState({
    isLoginSelected: true,
    isSkipLoginSelected: false,
  });
  const { isLoginSelected, isSkipLoginSelected } = state;
  const WelcomeScreenKeyHandler = (event) => {
    if (event.keyCode !== undefined) {
      switch (event.keyCode) {
        case 13:
          if (selectedElementIndx == 0) {
            navigate("LanguagePage");
            selectedElementIndx = 0;
          } else if (selectedElementIndx == 1) {
            navigate("HomePage");
            selectedElementIndx = 0;
          }
          window.removeEventListener("keydown", WelcomeScreenKeyHandler);
          break;
        case 39:
          setState(() => ({
            isLoginSelected: false,
            isSkipLoginSelected: true,
          }));
          selectedElementIndx = 1;
          break;
        case 37:
          setState(() => ({
            isLoginSelected: true,
            isSkipLoginSelected: false,
          }));
          selectedElementIndx = 0;
          break;
        default:
          break;
      }
    }
  };
  useEffect(() => {
    window.addEventListener("keydown", WelcomeScreenKeyHandler);
    return () => {
      window.removeEventListener("keydown", WelcomeScreenKeyHandler);
    };
  }, []);
  const styles = {
    welcomeContainer: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
      color: "#333",
      fontSize: "1.5em",
      backgroundImage: "url(./assets/welcomebg.png)",
      backgroundSize: "cover",
      backgroundPosition: "center", // Center the background image
      backgroundRepeat: "no-repeat", // Do not repeat the background image
      overflow: "hidden",
    },
  };
  return (
    <div style={styles.welcomeContainer}>
      <CustomButton
        navigateTo="/login"
        fontSize={resolution === "FHD" ? "24px" : "18px"}
        defaultSelected={isLoginSelected}
        width={resolution === "FHD" ? "13vw" : "13vw"}
        height={resolution === "FHD" ? "7vh" : "7vh"}
        top={resolution === "FHD" ? "85vh" : "85vh"}
        left={resolution === "FHD" ? "55vw" : "55vw"}
        onClick={WelcomeScreenKeyHandler}
        onKeyDown={WelcomeScreenKeyHandler}
      >
        Login
      </CustomButton>
      <CustomButton
        navigateTo="/homepage"
        fontSize={resolution === "FHD" ? "24px" : "18px"}
        defaultSelected={isSkipLoginSelected}
        height={resolution === "FHD" ? "7vh" : "7vh"}
        width={resolution === "FHD" ? "13vw" : "13vw"}
        top={resolution === "FHD" ? "85vh" : "85vh"}
        left={resolution === "FHD" ? "85vw" : "85vw"}
        onClick={WelcomeScreenKeyHandler}
        onKeyDown={WelcomeScreenKeyHandler}
      >
        Skip Login
      </CustomButton>
    </div>
  );
};

// const styles = {
//   welcomeContainer: {
//     display: 'flex',
//     flexDirection: 'column',
//     justifyContent: 'center',
//     alignItems: 'center',
//     height: '100vh',
//     color: '#333',
//     fontSize: '1.5em',
//     backgroundImage: 'url(./assets/welcomebg.png)',
//     backgroundSize: 'cover',
//     backgroundPosition: 'center', // Center the background image
//     backgroundRepeat: 'no-repeat', // Do not repeat the background image
//   },
// };

export default WelcomeScreen;
